import axios from 'axios'

function processError(store, mutationTypes, error) {
    console.log(error)
    setPendingFlag(store, mutationTypes, false)
    let code = 404
    let errorMsg = error.message

    if (error.response) {
        code = error.response.status

        console.log(error.response.data)

        if (error.response.data.message && error.response.data.message != 'An error has occurred.')
            errorMsg = error.response.data.message
        else if (error.response.data.exceptionMessage)
            errorMsg = error.response.data.exceptionMessage
    }

    store.commit(mutationTypes.BASE, { type: mutationTypes.FAILURE, errorMessage: errorMsg, statusCode: code })
}

function processResponse(store, mutationTypes, response, callback) {
    let data
    if (callback) data = callback(response)
    else data = response.data

    store.commit(mutationTypes.BASE, { type: mutationTypes.SUCCESS, data, statusCode: response.status })
    setPendingFlag(store, mutationTypes, false)
}

function reset(store, mutationTypes) {
    store.commit(mutationTypes.BASE, { type: mutationTypes.FAILURE, errorMessage: null, statusCode: null })
    store.commit(mutationTypes.BASE, { type: mutationTypes.SUCCESS, value: {} })
}

function setPendingFlag(store, mutationTypes, flag) {
    store.commit(mutationTypes.BASE, { type: mutationTypes.PENDING, value: flag })
}

export const doAsyncGet = (store, { url, mutationTypes, callback }) => {
    reset(store, mutationTypes)
    setPendingFlag(store, mutationTypes, true)

    return axios.get(url)
        .then(response => {
            processResponse(store, mutationTypes, response, callback)
        })
        .catch(error => {
            processError(store, mutationTypes, error)
        })
}

export const doAsyncDelete = (store, { url, mutationTypes }) => {
    reset(store, mutationTypes)
    setPendingFlag(store, mutationTypes, true)

    return axios.delete(url)
        .then(response => {
            processResponse(store, mutationTypes, response, null)
        })
        .catch(error => {
            processError(store, mutationTypes, error)
        })
}

export const doAsyncPost = (store, { url, mutationTypes, payload, callback }) => {
    reset(store, mutationTypes)
    setPendingFlag(store, mutationTypes, true)

    return axios.post(url, payload)
        .then(response => {
            processResponse(store, mutationTypes, response, callback)
        })
        .catch(error => {
            processError(store, mutationTypes, error)
        })
}

export const doAsyncPut = (store, { url, mutationTypes, payload, callback }) => {
    reset(store, mutationTypes)
    setPendingFlag(store, mutationTypes, true)

    return axios.put(url, payload)
        .then(response => {
            processResponse(store, mutationTypes, response, callback)
        })
        .catch(error => {
            processError(store, mutationTypes, error)
        })
}

export const getComparisonReport = (store, { url, mutationTypes, payload, callback }) => {
    reset(store, mutationTypes)
    setPendingFlag(store, mutationTypes, true)

    return axios.post(url, payload, {
        responseType: 'blob'
    })
        .then(response => {
            processResponse(store, mutationTypes, response, callback)
            let blob = new Blob([response.data], { type: 'application/pdf' })
            let filename = 'RightSpec CrossReference Comparison Report.pdf'

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, filename)
                return
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            let link = document.createElement('a')
            const data = window.URL.createObjectURL(blob)
            link.href = data
            link.download = filename
            link.click()

            setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                document.body.removeChild(link)
                window.URL.revokeObjectURL(data)
            }, 100)
        })
        .catch(error => {
            processError(store, mutationTypes, error)
        })
}
